// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FClxZ","wrapper":"styles_wrapper__Sr4A4","user":"styles_user__1-OQr","blockTitle":"styles_blockTitle__BxVzv"};